import React from "react";
import Tippy from "@tippyjs/react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { PaperFormIcon } from "fe-shared/src/components/Icons";

import styles from "./PaperFormIndicator.module.scss";

interface Props {
  isPaperForm?: boolean;
  className?: string;
}

export const PaperFormIndicator = ({ isPaperForm, className }: Props) => {
  const { t } = useTranslation();

  return isPaperForm ? (
    <Tippy content={t("transactions.paperForm")}>
      <div className={classnames(styles.icon, className)}>
        <PaperFormIcon width={16} height={16} fillColor="#63696F" />
      </div>
    </Tippy>
  ) : null;
};

export default PaperFormIndicator;
